class PecadoVideo extends HTMLElement {
    constructor() {
        super();

        this.selector = {
            video: 'video',
            playPauseBtn: '.js-sh-play-pause',
            playBtn: '.js-sh-play',
            pauseBtn: '.js-sh-pause',
        }

        this.elements = {
            video: this.querySelector(this.selector.video),
            playPauseBtn: this.querySelector(this.selector.playPauseBtn),
            playBtn: this.querySelector(this.selector.playBtn),
            pauseBtn: this.querySelector(this.selector.pauseBtn),
        }

        this.classes = {
            hide: 'hide',
        }

        this.init();
    }

    init() {
        this.elements.playPauseBtn.addEventListener('click', () => {
            if (this.elements.video.paused) {
                this.elements.video.play();
                this.elements.playBtn.classList.add(this.classes.hide);
                this.elements.pauseBtn.classList.remove(this.classes.hide);
            } else {
                this.elements.video.pause();
                this.elements.playBtn.classList.remove(this.classes.hide);
                this.elements.pauseBtn.classList.add(this.classes.hide);
            }
        });
    }
}

customElements.define('pecado-video', PecadoVideo);